import { deepCopy } from '../../../../../shared/utils';
import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import {
  AUTO_MAP_COST_FILE_TEMPLATE,
  CLEAR_COST_FILE_TEMPLATE,
  CLEAR_COST_FILE_TEMPLATE_MAP,
  type CostFileTemplateCreatorAction,
  EDIT_COST_FILE_TEMPLATE,
  SET_COST_FILE_SAMPLE,
  UPDATE_COST_FILE_TEMPLATE_AD_PARTNER,
  UPDATE_COST_FILE_TEMPLATE_FIELD,
  UPDATE_COST_FILE_TEMPLATE_STEP,
  UPDATE_COST_FILE_TEMPLATE_TITLE,
} from './actions';
import { INIT_STATE } from './constants/costFileTemplateCreatorInitState';
import { COST_FILE_TEMPLATE_CREATOR_STEPS } from './constants/costFileTemplateCreatorSteps';
import type { CostFileTemplateCreatorState } from './types';

const handler = (
  state: WrappedReducer<CostFileTemplateCreatorState>,
  action: CostFileTemplateCreatorAction
): WrappedReducer<CostFileTemplateCreatorState> => {
  switch (action.type) {
    case CLEAR_COST_FILE_TEMPLATE: {
      return deepCopy(INIT_STATE);
    }
    case CLEAR_COST_FILE_TEMPLATE_MAP: {
      const mapping = deepCopy(state.mapping);
      mapping.forEach((field) => {
        field.branchKeyOption = undefined;
      });

      return { ...state, mapping };
    }
    case UPDATE_COST_FILE_TEMPLATE_STEP: {
      const data = { ...action.data } as Partial<CostFileTemplateCreatorState>;
      switch (data.step) {
        case COST_FILE_TEMPLATE_CREATOR_STEPS.START: {
          data.startStepVisited = true;
          break;
        }
        case COST_FILE_TEMPLATE_CREATOR_STEPS.MAP: {
          data.mapStepVisited = true;
          break;
        }
        case COST_FILE_TEMPLATE_CREATOR_STEPS.VALIDATE: {
          data.validateStepVisited = true;
          break;
        }
      }

      return { ...state, ...data };
    }
    case UPDATE_COST_FILE_TEMPLATE_TITLE: {
      return { ...state, title: action.data.title };
    }
    case UPDATE_COST_FILE_TEMPLATE_AD_PARTNER: {
      return { ...state, ...action.data };
    }
    case SET_COST_FILE_SAMPLE: {
      return { ...state, ...action.data };
    }
    case UPDATE_COST_FILE_TEMPLATE_FIELD: {
      const { mappingIndex, sourceKey, branchKeyOption } = action.data;
      const mapping = deepCopy(state.mapping);
      if (mapping[mappingIndex]?.sourceKey === sourceKey) {
        mapping[mappingIndex].branchKeyOption = branchKeyOption;
      }

      return { ...state, mapping };
    }
    case EDIT_COST_FILE_TEMPLATE: {
      return { ...state, ...action.data };
    }
    case AUTO_MAP_COST_FILE_TEMPLATE: {
      return { ...state, mapping: action.data };
    }
    default: {
      return state;
    }
  }
};

const CostFileTemplateCreatorReducer = ReduxAsyncActionsService.wrapReducer(deepCopy(INIT_STATE), handler, {});

export default CostFileTemplateCreatorReducer;
